import { createContext } from '@lit/context';
export const sceneContext = createContext(Symbol('scene context'));
//# sourceMappingURL=scene-context.token.js.map